/**
 * Service for rendering custom html symbols
 */

import {Injectable} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {SafeHtml} from '@angular/platform-browser';

const HTML_SYMBOLS = {
    MDASH: '&mdash;' // Long dash
};

@Injectable()
export class HtmlSymbolService {

    private compiledSymbols: {[key: string]: SafeHtml} = {};

    constructor(
        private domSanitizerService: DomSanitizer
    ) {
        this.compiledSymbols['mdash'] = this.domSanitizerService.bypassSecurityTrustHtml(HTML_SYMBOLS.MDASH);
    }

    public mdash(): SafeHtml {
        return this.compiledSymbols['mdash'];
    }
}
